/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetResourceQuery, Resource } from "~/generated/graphql";

type Props = {
  resourceId: string;
};

export function useGetResource({ resourceId }: Props) {
  const { data, loading, error } = useGetResourceQuery({
    variables: { resourceId },
  });

  return { resource: data?.resource as Resource, loading, error } as const;
}
